// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.base[data-v-cb8da14c] {\r\n    padding: 1em;\n}\n.top[data-v-cb8da14c] {\r\n    width: 90%;\r\n    height: 4em;\r\n    margin: auto;\n}\n.title[data-v-cb8da14c] {\r\n    float: left;\r\n    padding: 1em;\n}\n.button[data-v-cb8da14c] {\r\n    float: right;\r\n    padding: 1em;\r\n    font-weight: bold;\r\n    background: #CCCCCC;\r\n    border-radius: 10ch;\r\n    cursor: pointer;\n}\r\n", ""]);
// Exports
module.exports = exports;
